"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _v = _interopRequireDefault(require("uuid/v1"));
var _papaparse = _interopRequireDefault(require("papaparse"));
var _flat = _interopRequireDefault(require("flat"));
var _helpers = require("../helpers");
var _WebRequestHelper = require("../helpers/WebRequestHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const mapStateToProps = (state, props) => {
  return {
    [props.entity.plural]: state[props.entity.plural]
  };
};
const mapDispatchToProps = (dispatch, props) => {
  return {
    create: (0, _redux.bindActionCreators)(props.actions.create, dispatch),
    update: (0, _redux.bindActionCreators)(props.actions.update, dispatch),
    getAll: (0, _redux.bindActionCreators)(props.actions.getAll, dispatch)
  };
};
const validate = (data, schema) => {
  const array = [...data];
  let errors = [];
  return new Promise(resolve => {
    const validated = array.map(item => {
      item = Object.entries(item).filter(([key, value]) => !!value.length) //removing empty entries
      .reduce((obj, [key, value]) => {
        obj[key] = value;
        return obj;
      }, {});
      let row = _flat.default.unflatten(item);
      for (const [key, value] of Object.entries(row)) {
        if (key !== "Category" && key !== "TranslationId" && key !== "Comment") {
          row.LanguageId = key;
          row.Value = value;
        }
      }
      row = Object.entries(row).filter(([key, value]) => schema.hasOwnProperty(key)) //removing unknown attributes
      .reduce((obj, [key, value]) => {
        obj[key] = value;
        return obj;
      }, {});
      row = Object.entries(row).filter(([key, value]) => {
        switch (schema[key].type) {
          case "Join":
            if (value.constructor !== Array) {
              errors.push(`Value removed because ${key} was not type of Array`);
              return false;
            }
            break;
          case "String":
          case "Email":
            if (value.constructor !== String) {
              errors.push(`Value removed because ${key} was not type of String`);
              return false;
            }
            break;
        }
        return true;
      }).reduce((obj, [key, value]) => {
        obj[key] = value;
        return obj;
      }, {});
      return {
        ...row,
        Id: (0, _v.default)()
      };
    });
    resolve({
      validated,
      errors
    });
  });
};
const getAllLanguages = () => {
  return (0, _WebRequestHelper.createRequest)(true).then(request => {
    request.method = "get";
    request.url = `/languages`;
    return (0, _WebRequestHelper.sendRequest)(request).then(response => {
      return response.data;
    }).catch(err => console.dir(err));
  }).catch(err => console.dir(err));
};
const getAllTranslations = () => {
  return (0, _WebRequestHelper.createRequest)(true).then(request => {
    request.method = "get";
    request.url = `languages?expand=TranslationEntries`;
    return (0, _WebRequestHelper.sendRequest)(request).then(response => {
      let translationsAndLanguage = {};
      let index = 0;
      for (let language of response.data) {
        for (let translationEntry of language.TranslationEntries) {
          translationsAndLanguage[index] = {
            Id: translationEntry.Id,
            TranslationId: translationEntry.TranslationId,
            Value: translationEntry.Value,
            Category: translationEntry.Category,
            Comment: translationEntry.Comment,
            LanguageId: language.Id,
            LanguageName: language.DisplayName
          };
          index += 1;
        }
      }
      let translationsGroupedByTranslationId = Object.values(translationsAndLanguage).reduce(function (r, a) {
        r[a.TranslationId] = r[a.TranslationId] || [];
        r[a.TranslationId].push(a);
        return r;
      }, Object.create(null));
      let translationsObject = {};
      for (let translationGroup in translationsGroupedByTranslationId) {
        let commonTranslationData = translationsGroupedByTranslationId[translationGroup][0];
        translationsObject[translationGroup] = {
          TranslationId: commonTranslationData.TranslationId,
          Category: commonTranslationData.Category,
          Comment: commonTranslationData.Comment
        };
        for (let languageGroup of translationsGroupedByTranslationId[translationGroup]) {
          let langName = languageGroup.LanguageName;
          let transValue = languageGroup.Value;
          translationsObject[translationGroup][langName] = transValue;
        }
      }
      return translationsObject;
    }).catch(err => console.dir(err));
  }).catch(err => console.dir(err));
};
class BaseImportTranslations extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      data: [],
      selection: [],
      errors: [],
      messages: [],
      fetching: false,
      fetched: true,
      outsideSchema: {},
      translationEntries: {}
    });
    _defineProperty(this, "generateExampleCSV", (data, schema) => {
      if (Object.entries(data).length !== 0 && Object.entries(schema).length !== 0) {
        let columnsArray = [];
        for (let language in schema) {
          columnsArray.push(language);
        }
        const serialized = _papaparse.default.unparse(data, {
          columns: columnsArray
        }); // JSON -> CSV

        const text = new Blob([serialized], {
          type: "text/csv"
        });
        return window.URL.createObjectURL(text);
      }
      return null;
    });
    _defineProperty(this, "handleImport", event => {
      const file = event.target.files[0];
      const textType = /text\/*|application\/vnd.ms-excel/;
      if (!!file.type.match(textType) || file.name.toLowerCase().endsWith("csv")) {
        const {
          [this.props.entity.plural]: store
        } = this.props;
        _papaparse.default.parse(file, {
          header: true,
          complete: results => {
            for (let i = 0; i < results.data.length; i++) {
              // Remove elements without TranslationId
              if (!results.data[i].TranslationId) {
                results.data.splice(i, 1);
              }
            }
            validate(results.data, this.state.outsideSchema).then(({
              validated,
              errors
            }) => {
              this.setState({
                data: validated
              });
              !!errors.length && errors.map(error => this.throw(error));
            });
          }
        });
      } else {
        return this.setState(prev => {
          return {
            errors: [...prev.errors, {
              Message: "Wrong file type provided. Please choose a CSV.",
              Id: (0, _v.default)()
            }]
          };
        });
      }
    });
    _defineProperty(this, "handleDelete", () => {
      this.setState(prev => {
        return {
          data: prev.data.filter(item => !prev.selection.includes(item.Id)),
          selection: []
        };
      });
    });
    _defineProperty(this, "handleSelect", (bool, id) => {
      if (bool) return this.setState(prev => {
        return {
          selection: [...prev.selection, id]
        };
      });
      return this.setState(prev => {
        return {
          selection: prev.selection.filter(p => p !== id)
        };
      });
    });
    _defineProperty(this, "handleSelectAll", bool => {
      if (bool) {
        const all = this.state.data.map(item => item.Id);
        return this.setState({
          selection: all
        });
      }
      return this.setState({
        selection: []
      });
    });
    _defineProperty(this, "handleChange", (attr, value, row) => {
      return new Promise(resolve => {
        this.setState(prev => {
          return {
            data: prev.data.map(item => {
              if (item.Id === row) item[attr] = value;
              return item;
            })
          };
        });
        resolve();
      });
    });
    _defineProperty(this, "handleAdd", (prop, name, join, row) => {
      return new Promise(resolve => {
        this.setState(prev => {
          return {
            data: prev.data.map(item => {
              if (item.Id === row) item[prop] = [...(item[prop] ? item[prop] : []), {
                [name]: join.Id
              }];
              return item;
            })
          };
        });
        resolve();
      });
    });
    _defineProperty(this, "handleDrop", (prop, name, join, row) => {
      return new Promise(resolve => {
        this.setState(prev => {
          return {
            data: prev.data.map(item => {
              if (item.Id === row) item[prop] = item[prop].filter(p => p[name] !== join[name]);
              return item;
            })
          };
        });
        resolve();
      });
    });
    _defineProperty(this, "handleSubmit", event => {
      event.preventDefault();
      const {
        create,
        update,
        getAll,
        entity
      } = this.props;
      this.setState({
        fetching: true
      });
      let i = 0;
      const {
        data
      } = this.state;
      const languages = this.state.languages;
      let dataFormatted = []; // Data formatted to match internal translationentries schema

      for (const row in data) {
        if (!("Comment" in data[row])) data[row].Comment = "";
        for (const language in languages) {
          let lang = languages[language].DisplayName;
          if (lang in data[row]) {
            let newTranslationEntry = {
              Id: (0, _v.default)(),
              TranslationId: data[row].TranslationId,
              Category: data[row].Category,
              Comment: data[row].Comment,
              LanguageId: languages[language].Id,
              Value: data[row][lang]
            };
            dataFormatted.push(newTranslationEntry);
          }
        }
      }
      const importRequest = () => {
        return getAllTranslations().then(translations => {
          if (dataFormatted[i].TranslationId in translations) {
            return (0, _WebRequestHelper.createRequest)(true).then(request => {
              request.method = "get";
              request.url = `/translationentries?filter=TranslationId != null and TranslationId.Equals("${dataFormatted[i].TranslationId}")`;
              return (0, _WebRequestHelper.sendRequest)(request).then(response => {
                for (let index = 0; index < response.data.length; index++) {
                  if (response.data[index].LanguageId === dataFormatted[i].LanguageId) {
                    let updateElementId = response.data[index].Id;
                    return update(updateElementId, dataFormatted[i]).then(() => {
                      this.setState(prev => {
                        return {
                          dataFormatted: prev.data.filter(p => p.Id !== dataFormatted[i].Id)
                        };
                      });
                      i++;
                      if (i >= dataFormatted.length) {
                        this.message(`Data successfully imported`);
                        this.setState({
                          data: [],
                          fetching: false
                        });
                        return "done";
                      }
                      return importRequest();
                    }).catch(err => {
                      this.setState({
                        fetching: false
                      });
                      console.dir(err);
                      this.throw(`There was an error updating the data`);
                      i++;
                      if (i >= dataFormatted.length) return "done";
                      return importRequest();
                    });
                  }
                }
                return create(dataFormatted[i]).then(() => {
                  this.setState(prev => {
                    return {
                      dataFormatted: prev.data.filter(p => p.Id !== dataFormatted[i].Id)
                    };
                  });
                  i++;
                  if (i >= dataFormatted.length) {
                    this.message(`Data successfully imported`);
                    this.setState({
                      data: [],
                      fetching: false
                    });
                    return "done";
                  }
                  return importRequest();
                }).catch(err => {
                  this.setState({
                    fetching: false
                  });
                  console.dir(err);
                  this.throw(`There was an error importing the data`);
                  i++;
                  if (i >= dataFormatted.length) return "done";
                  return importRequest();
                });
              }).catch(err => console.dir(err));
            }).catch(err => console.dir(err));
          } else {
            return create(dataFormatted[i]).then(() => {
              this.setState(prev => {
                return {
                  dataFormatted: prev.data.filter(p => p.Id !== dataFormatted[i].Id)
                };
              });
              i++;
              if (i >= dataFormatted.length) {
                this.message(`Data successfully imported`);
                this.setState({
                  data: [],
                  fetching: false
                });
                return "done";
              }
              return importRequest();
            }).catch(err => {
              this.setState({
                fetching: false
              });
              console.dir(err);
              this.throw(`There was an error importing the data`);
              i++;
              if (i >= dataFormatted.length) return "done";
              return importRequest();
            });
          }
        });
      };
      return importRequest();
    });
    _defineProperty(this, "throw", message => {
      this.setState(prev => {
        return {
          errors: [...prev.errors, {
            Id: (0, _v.default)(),
            Message: message
          }]
        };
      });
    });
    _defineProperty(this, "message", message => {
      this.setState(prev => {
        return {
          messages: [...prev.messages, {
            Id: (0, _v.default)(),
            Message: message
          }]
        };
      });
    });
    _defineProperty(this, "handleRead", id => {
      this.setState(prev => {
        return {
          errors: prev.errors.filter(error => error.Id !== id),
          messages: prev.messages.filter(message => message.Id !== id)
        };
      });
    });
    _defineProperty(this, "render", () => {
      const {
        children,
        entity,
        ...rest
      } = this.props;
      const {
        errors,
        messages,
        fetching,
        fetched,
        selection,
        data,
        outsideSchema,
        translationEntries
      } = this.state;
      return _react.default.cloneElement(children, {
        ...rest,
        state: data,
        errors: errors,
        messages: messages,
        fetching: fetching,
        fetched: fetched,
        selection: selection,
        schema: outsideSchema,
        entity,
        fields: (0, _helpers.objectToArray)(outsideSchema),
        exampleFile: this.generateExampleCSV(translationEntries, outsideSchema),
        onChange: this.handleChange,
        onSelect: this.handleSelect,
        onSelectAll: this.handleSelectAll,
        onSubmit: this.handleSubmit,
        onImport: this.handleImport,
        onDelete: this.handleDelete,
        onRead: this.handleRead,
        onAdd: this.handleAdd,
        onDrop: this.handleDrop
      });
    });
  }
  componentDidMount() {
    let newSchema = {
      Category: {
        displayName: "Category",
        type: "String",
        value: "",
        guarded: true,
        sortable: true,
        filterable: true
      },
      TranslationId: {
        displayName: "ID",
        type: "String",
        value: "",
        guarded: true,
        sortable: true,
        filterable: true
      }
    };
    const {
      [this.props.entity.plural]: store
    } = this.props;
    getAllLanguages().then(languages => {
      this.setState({
        languages: {
          ...languages
        }
      });
      for (const language of languages) {
        newSchema[language.DisplayName] = {
          displayName: language.DisplayName,
          type: "String",
          value: "",
          sortable: true,
          filterable: true
        };
      }
      newSchema = {
        ...newSchema,
        ...store.import.schema
      };
      delete newSchema.Value;
      this.setState({
        outsideSchema: {
          ...newSchema
        }
      });
      getAllTranslations().then(translations => {
        let jsonWithTranslations = JSON.stringify(Object.values(translations));
        this.setState({
          translationEntries: jsonWithTranslations
        });
      });
    });
  }
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BaseImportTranslations);
module.exports = exports.default;